














import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-avatar' })
export default class VAvatar extends Vue {
    /**
     * User name
     */
    @Prop({ type: String, default: '?' })
    name!: string

    /**
     * Image source
     */
    @Prop({ type: String })
    image!: string

    /**
     * Image source
     */
    @Prop({ type: String, default: 'md' })
    size!: 'sm' | 'md' | 'lg'

    /**
     * Whether to show a small tail at the bottom of the image
     */
    @Prop({ type: Boolean, default: false })
    tail!: boolean

    get initials(): string {
        return this.name.split(' ')
            .map(word => word.substr(0, 1))
            .join('')
            .substr(0, 2)
            .toUpperCase()
    }
}
